import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-section" }
const _hoisted_2 = { class: "flex items-center px-6 pt-16 pb-6" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "content-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card-image-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "card-content" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "card-subtitle" }
const _hoisted_11 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_12 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_13 = { class: "empty-title" }
const _hoisted_14 = { class: "empty-subtitle" }

import { ref } from 'vue';
import {
	IonContent,
	IonButton,
	IonFooter,
	IonIcon,
	IonSpinner,
	IonRefresher,
	IonRefresherContent,
	RefresherCustomEvent,
} from '@ionic/vue';
import {
	chevronBack,
	search
} from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';

import useQueue from '@/modules/queue/composables/useQueue';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'QueueCategoryActivitiesPage',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

// Get category ID from route params
const categoryId = parseInt(route.params.categoryId as string);
const categoryName = ref(route.params.categoryName as string || 'Category');

// Queue composable
const { getQueueSubActivities } = useQueue();
const { subActivities, isFetchedSubActivities, refetchSubActivities } = getQueueSubActivities(categoryId);

// Pull to refresh
const handleRefresh = async (event: RefresherCustomEvent) => {
	await refetchSubActivities();
	event.target.complete();
};

// Navigate to activity detail
const goToActivity = (activityId: number) => {
	router.push(`/queue/${activityId}`);
};

// Go back
const goBack = () => {
	router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), { class: "queue-category-activities-page" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          slot: "fixed",
          onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (handleRefresh($event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonButton), {
              fill: "clear",
              color: "light",
              onClick: goBack,
              class: "back-button"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(chevronBack),
                  class: "back-icon"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _createElementVNode("h1", _hoisted_3, _toDisplayString(categoryName.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_unref(subActivities) && _unref(subActivities).length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['activities-list', { 'activities-grid': _unref(subActivities).length > 1 }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subActivities), (activity) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: activity.id,
                    class: "activity-card",
                    onClick: ($event: any) => (goToActivity(activity.id))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: activity.image_url || activity.main_image_url || '/api/placeholder/400/240',
                        alt: activity.name,
                        class: "card-image"
                      }, null, 8, _hoisted_7),
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-gradient-overlay" }, null, -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h3", _hoisted_9, _toDisplayString(activity.name), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(activity.short_description || 'Experience the excitement'), 1)
                      ])
                    ])
                  ], 8, _hoisted_5))
                }), 128))
              ], 2))
            : (!_unref(isFetchedSubActivities))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(IonSpinner), { name: "circular" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(search),
                    class: "empty-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("h3", _hoisted_13, _toDisplayString(_unref(t)('queue.no_activities_available')), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('queue.check_back_later')), 1)
                ]))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "h-[100px]" }, " ", -1))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter))
  ], 64))
}
}

})